module.exports = ".scene {\n  width: 100%;\n  height: 500px;\n}"